import Faq from '../components/Faq'
import BreedServices from '../components/BreedServices'
import NewsLetter from '../components/NewsLetter'
import ShopAreaCat from '../components/ourshop/ShopAreaCat';
import BreadCumbcat from '../components/catlists/BreadCumb';
import { useEffect } from 'react';
import ShopAreaRongeur from '../components/ourshop/ShoAreaRongeur';
import BreadCumbrongeur from '../components/catlists/BreadCumbRong';
import { Helmet } from 'react-helmet-async';


function RongeurList() {
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);


    return (

        <main>
            			 <Helmet>
        <title>Rongeurs - Animalia</title>
        <meta name="description" content="Découvrez notre sélection de nos produits pour rongeurs chez Animalia." />
      </Helmet>

            <BreadCumbrongeur/>
            {/* <DogsList/> */}
            <ShopAreaRongeur />
            {/* <AdoptionShop/> */}
            <Faq afterElment="faq-area-two" />
            <BreedServices />
            <NewsLetter />
        </main>
    )
}

export default RongeurList;
